import { useT } from '@/i18n';

export function MenuImportReviewBanner({ onOpen }: { onOpen: () => void }) {
  const c = useT().menuImportReview;
  return (
    <div className="menu-legend" data-testid="menu-import-review-banner">
      <button
        type="button"
        className="menu-legend__offer"
        onClick={onOpen}
        data-testid="menu-import-review-open"
      >
        <i className="f7-icons" aria-hidden="true">
          doc_text_viewfinder
        </i>
        <span>{c.open}</span>
      </button>
    </div>
  );
}
